/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 17:31:25 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListTowerInspectionQuery = gql`
  query allTowerInspections(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: TowerInspectionFilter
  ) {
    items: allTowerInspections(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      cmsStatus
      tower {
        id
        cmsStatus
        site {
          id
          name
          project {
            id
            name
            checklistType
            organisation {
              id
              name
            }
          }
        }
        type {
          id
        }
        status
        platformHeight
        description
      }
      permissions {
        allowPDFExport
      }
      inspectedAt
      inspectionNumber
      status
      isExpiryImminent
      isExpired
    }
    total: _allTowerInspectionsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;

export default ({ client, params }) => {
  try {
    // account for pagination not being reduced on custom lists
    return client.query({
      query: getListTowerInspectionQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort.field,
        sortOrder: params.sort.order,
        page:
          params.pagination && params.pagination.page > 0
            ? params.pagination.page - 1
            : params.pagination.page,
        perPage: params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
